import React from 'react';
import MainButton from '@ui-kit/components/mainButton';
import btnLeave from './assets/images/btnLeave.png';
import { container } from 'tsyringe';
import { t, useSubject } from '../../../../../utils/helpers';
import { useHistory } from 'react-router-dom';
import { ITable } from '@base/features/game/model/interfaces';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import PlayersOnlineRepository from '@base/features/player/model/playersOnlineRepository';
import BaseTablesRepository from '@base/features/game/model/baseTableRepository';
import SocketClient from '@base/features/socket/socketClient';
import { SOCKET_CONNECTION_STATE } from '@base/features/socket/interfaces';

export const TournamentsBtnLeave = () => {
  const socketClient: SocketClient = container.resolve('socketClient');
  const playersOnlineRepository: PlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const tablesRepository: BaseTablesRepository<ITable> = container.resolve('tableRepository');
  useSubject(socketClient.onConnect);

  const history = useHistory();

  function leaveTournament(): void {
    socketClient.connectDefault();
    playersOnlineRepository.clear();
    tablesRepository.cleanTables();
    history.push(MAIN_ROUTES.lobby);
  }

  if (!socketClient.isConnected() || socketClient.isConnectedToDefault()) return null;

  return (
    <div className="btn-leave-wrap">
      <MainButton
        className="btn-leave"
        onClick={leaveTournament}
        disabled={socketClient.isConnectedToDefault()}
      >
        <div className="btn-leave-img">
          <img src={btnLeave} alt="button leave" />
          <div style={{ paddingLeft: '10px' }}>{t('leave_tournaments')}</div>
        </div>
      </MainButton>
    </div>
  );
};
